module.exports = __webpack_public_path__ + "static/media/cafe-word-w.b0424962.svg";